module.exports = "<div class=\"m-maintain-info\" v-if=\"isRender\">\r\n    <div class=\"container\">\r\n        <div class=\"title\">保养贴士</div>\r\n        <div class=\"separator\">-</div>\r\n        <div class=\"desc\" v-html=\"ln2br(maintainText)\"></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/gallery/maintain-info.html
// module id = 327
// module chunks = 0